
const Invoices = (state = { invoices: [] }, action) => {

  switch(action.type) {

    case 'SET_INVOICES':
      return {
        ...state,
        invoices: action.invoices,
      }
    default:
      return state;
  }
};

export default Invoices;



// WEBPACK FOOTER //
// ./src/reducers/InvoicesReducer.js